import { createContext } from 'react';
import { LeadTrackingPageSource } from 'types/Apis/LeadTrackingParams';
import { SourcePages } from 'lib/EventSchema';

interface QuickPicksEventContextInfo {
  leadTrackingSourceDesktop: LeadTrackingPageSource;
  leadTrackingSourceMobile: LeadTrackingPageSource;
  sourceQP?: SourcePages;
  sourcePage: SourcePages;
  sourcePageCategory: string;
}

export default createContext<QuickPicksEventContextInfo>({
  leadTrackingSourceDesktop: '' as LeadTrackingPageSource,
  leadTrackingSourceMobile: '' as LeadTrackingPageSource,
  sourcePage: '' as SourcePages,
  sourcePageCategory: '',
});
